module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead5-f6d3cbffbf0241574e249bc1e5aa2c57.jpg";